import { render } from "./uiPageSectionBox.vue?vue&type=template&id=fd79103a"
import script from "./uiPageSectionBox.vue?vue&type=script&lang=js"
export * from "./uiPageSectionBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__